<template>
    <div class="icon-button" :class="{ [classNames]: true }" @click="onClick">
        <slot />
    </div>
</template>

<script>
export default {
    name: "IconButton",
    props: {
        onClick: {
            type: Function,
            default: () => {},
        },
        classNames: {
            type: String,
            default: "",
        },
    },
};
</script>

<style scoped lang="scss">
.icon-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    padding: 5px;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
        background-color: var(--color-bg-ghost-hover);
    }

    &:active {
        background-color: var(--color-bg-ghost-hover);
    }

    svg {
        width: 20px;
        height: 20px;
    }
}
</style>
